// extracted by mini-css-extract-plugin
module.exports = {"box":"Divider_box___au5x","label":"Divider_label__kdoNX"};